import { setActivePaginationLimit, setActivePaginationPage } from "@global-state/pages/admin/customers/slice";
import { useGetAllUsersQuery } from "@RTKQuery/admin/customers/customers";
import { Pagination, Select } from "@ui";
import { useAppSelector, useAppDispatch } from "store/hooks";

export function PaginationContainer() {
    const { activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeFilter } = useAppSelector(state => state.customersAdminPage);

    const { data } = useGetAllUsersQuery({
        limit: activePaginationLimit,
        page: activePaginationPage,
        search: activeSearchIdParameter,
        is_active: activeFilter
    });

    const dispatch = useAppDispatch();

    if (data?.count_item) {
        return (
            <div className="grid grid-cols-3 items-center justify-items-center mx-[40px] mb-[20px] max-sm:grid-cols-1 max-sm:gap-[20px]">
                <div></div>
                <Pagination
                    activePage={activePaginationPage - 1}
                    count={Math.ceil((data?.count_item || 0) / activePaginationLimit)}
                    onClickPage={(page) => {
                        dispatch(setActivePaginationPage(page + 1))
                    }}
                />
                <div className="justify-self-end max-sm:justify-self-center">
                    <Select
                        listAlign="top"
                        currentValue={{
                            label: String(activePaginationLimit),
                            value: String(activePaginationLimit)
                        }}
                        onChange={(value) => {
                            dispatch(setActivePaginationLimit(Number(value.value)))
                        }}
                        listValues={[
                            {
                                label: "50",
                                value: "50"
                            },
                            {
                                label: "100",
                                value: "100"
                            },
                            {
                                label: "150",
                                value: "150"
                            },
                            {
                                label: "200",
                                value: "200"
                            }
                        ]}
                    />
                </div>
            </div>
        )
    } else {
        return null;
    }
}